var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"850"},scopedSlots:_vm._u([{key:"activator",fn:function({}){return [_c('BaseButton',{attrs:{"text":_vm.localStorage.translations.pages.personnel_department.dialog_addemployee_buttons[
          'dobavit-sotrudnika'
        ],"default_icon":"button-add"},on:{"click":_vm.openModal}})]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.dialog)?_c('EmployeesCreateModalList',{attrs:{"closeModal":_vm.closeModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }